import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/material';
import { Styles } from '@t2c/shared-fe';
import { CustomPlayer } from '../video-player/CustomPlayer';
import { Button } from '@mui/material';
import { useRouter } from 'next/router';
import { useGetEditVideoData } from 'apps/t2c-fe/services';
import { handleDownloadVideoFile } from 'apps/t2c-fe/utils';
import { BrollVideosSection } from '../dashboard/BrollVideosSection';
import { ReferenceType } from 'libs/shared-fe/src/utils/constants';
import { useDialog } from 'apps/t2c-fe/hooks';
import ShareDialog from '../share/ShareDialog';

export const GeneratedBrollCaptionPreviewPage = () => {
  const { query, push } = useRouter();

  const videoId = query?.id as string;
  const {data, refetch:refetchById} = useGetEditVideoData({ id: videoId });
  
  const { name, renderedUrl } = data || {};

  const handleGenerate = () => {
    push('/broll-caption?action=create');
  };

  const theme = useTheme();
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    closeDialog: closeShareDialog,
    isDialogOpen: isShareDialogOpen,
    openDialog: openShareDialog,
  } = useDialog();

  return (
    <Box sx={styles.container}>
      <Box sx={{
        ...styles.previewContainer,
        borderWidth: isExtraSmall ? 'none' : '3px',
        padding: isExtraSmall ? 0 : '32px',
      }}>
        <Typography fontSize={24} fontWeight={500}>
          Captions & Effects Video
        </Typography>
        <Box sx={styles.name}>
          <Typography>{name}</Typography>
        </Box>
        <Box sx={{ maxWidth: '488px', alignSelf: 'center' }}>
          <CustomPlayer url={renderedUrl} height="376px" autoPlay={true} />
        </Box>
        <Box sx={styles.btns}>
          <Button
            variant="outlined"
            sx={{ 
              flex: 1,
              color: (theme) => theme.palette.text.primary,
              fontWeight: 500,
              backgroundColor: (theme) => theme.palette.background.secondary,
              borderColor: (theme) => theme.palette.background.border,
            }}
            onClick={handleGenerate}
          >
            Generate New Captions & Effect Video
          </Button>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Button
              variant="contained"
              onClick={() =>
                handleDownloadVideoFile({
                  name: name,
                  url: renderedUrl,
                  format: 'video',
                })
              }
              sx={{ flex: 1, color: (theme) => theme.palette.text.primary, boxShadow: 'none' }}
            >
              Download
            </Button>
            <Button
              variant="contained"
              onClick={() => push(`/upscale?refId=${videoId}&&referenceFrom=${ReferenceType.CAPTIONS}`)}
              sx={{ flex: 1, color: (theme) => theme.palette.text.primary, boxShadow: 'none' }}
            >
              Upscale
            </Button>
            {/* <Button
              variant="contained"
              onClick={openShareDialog}
              sx={{ flex: 1, color: (theme) => theme.palette.text.primary, boxShadow: 'none' }}
            >
              Share
            </Button> */}
          </Box> 
        </Box>
      </Box>
      <Box sx={styles.clipsSection}>
        <BrollVideosSection title='Recent Creations' refetchById={refetchById}/>
      </Box>
      {/* <ShareDialog
        open={isShareDialogOpen}
        onClose={closeShareDialog}
        url={renderedUrl}
      /> */}
    </Box>
  );
};

const styles: Styles = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  previewContainer: {
    backgroundColor: (theme) => theme.palette.background.primary,
    borderColor: (theme) => theme.palette.background.border,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '95%',
    gap: '32px',
    borderRadius: '16px',
    borderWidth: '3px',
    padding: '32px',
  },
  clipsSection: {
    width: '95%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  name: {
    p: 2,
    backgroundColor: (theme) => theme.palette.background.activeCard,
    alignItems: 'center',
    borderRadius: '4px',
    alignSelf: 'center',
  },
  btns: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: '100%',
    gap: 2,
  },
};
